"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const minigame_1 = require("../typeDefs/minigame");
const minigamePrizes = {
    'mystic-coin': [
        {
            minigame: 'Picross',
            difficulty: minigame_1.Difficulty.Easy,
            count: '2',
        },
        {
            minigame: 'Memory',
            difficulty: minigame_1.Difficulty.Easy,
            count: '2',
        },
    ],
    "the-spark": [
        {
            minigame: 'Memory',
            difficulty: minigame_1.Difficulty.Hard,
            count: '10',
        },
        {
            minigame: 'Picross',
            difficulty: minigame_1.Difficulty.Easy,
            count: '2',
        },
    ],
};
exports.default = {
    minigamePrizes,
};
